import { Row, Spin } from 'antd';

const FullPageLoader = (): JSX.Element => (
  <Row justify="center" align="middle" style={{ height: '100vh' }}>
    <Spin size="large" />
  </Row>
);

export default FullPageLoader;
